import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { systemApi } from '@/lib/api/system';
import type { FooterConfig } from '@comp-sys/shared';
import { DEFAULT_FOOTER_CONFIG } from '@comp-sys/shared';

export function useFooterConfig() {
  const { data, isLoading } = useQuery<FooterConfig>({
    queryKey: ['footer-config'],
    queryFn: systemApi.getFooterConfig,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    retry: 1,
  });

  const config = useMemo<FooterConfig>(() => ({
    copyrightText: data?.copyrightText || DEFAULT_FOOTER_CONFIG.copyrightText,
    icpFiling: { ...DEFAULT_FOOTER_CONFIG.icpFiling, ...data?.icpFiling },
    linkGroups: data?.linkGroups ?? [],
  }), [data]);

  return { config, isLoading };
}
